import CommonTNTControlBase from '../../../util/CommonTNTControlBase'

class ShiptypeBaseController extends CommonTNTControlBase {
  /*@ngInject*/
  constructor(Auth, $state, User, Service, Modal, $translate, $stateParams) {

    super(Auth, $state, User, Service, Modal, $translate, $stateParams)

    this.errors = {}
    this.loading = false
    this.errorMessage = ''
    this.model = {}
  }
  reset() {
    this.clearErrors()
    this.model = angular.copy(this.defaultModel)
  }
  askCreate() {
    this.Modal.confirm({
      header: this.$translate.instant('shiptype.create_another_title'),
      message: this.$translate.instant('shiptype.create_another_message'),
      callback: ({
        modal,
        $scope
      }) => {
        this.reset()
        modal.close()
      },
      negative: ({
        modal,
        $scope
      }) => {
        modal.close()
        window.history.go(-1)
      },
      type: 'primary',
      buttons: ['common.yes', 'common.no']
    })
  }
  validate() {
    this.clearErrors()
    for (let key in this.model) {
      if (!this.model[key]) {
        this.addError(key, key.charAt(0).toUpperCase() + key.slice(1) + ' is mandatory')
      }
    }
    return Object.keys(this.errors).length <= 0
  }

  clearErrors() {
    this.errors = {}
    this.errorMessage = ''
  }

  addError(id, message) {
    this.errors[id] = message
  }
}

export default ShiptypeBaseController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/shiptype/common/shiptype.base.controller.js